var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTwoFactorSetup = function SvgIconTwoFactorSetup(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    fill: "none",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#46B1D8",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M50 35.938H25v15.624h25V35.938zM31.25 35.938v-9.376c.005-1.656.665-3.242 1.836-4.414 1.171-1.17 2.758-1.83 4.414-1.835v0c1.656.004 3.243.665 4.414 1.835 1.171 1.172 1.831 2.758 1.836 4.415v9.375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#46B1D8",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M65.625 42.188c0 7.459-2.963 14.612-8.238 19.887-5.274 5.274-12.428 8.237-19.887 8.237-7.46 0-14.613-2.963-19.887-8.237-5.275-5.275-8.238-12.428-8.238-19.888v-31.25L37.5 4.688l28.125 6.25v31.25z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTwoFactorSetup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-two-factor-setup.05ce5992e8a54d504aad45df3f516728.svg";